(function () {
  var SECTION_SELECTOR = '.oddit-section-products-highlight';
  var GRABBING_CLASS = 'oddit-section-products-highlight__track--grabbing';

  // Desktop click-and-drag scrolling (mouse only; touch scrolls natively).
  // Cards stay clickable: a drag only starts once the pointer clearly moves,
  // and the click that follows a drag is swallowed so links don't fire.
  function initDrag(track, onDragEnd) {
    var DRAG_THRESHOLD = 6;
    var isDown = false;
    var dragging = false;
    var suppressClick = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      isDown = true;
      dragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      pointerId = e.pointerId;
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        // Nothing to scroll (e.g. mobile grid layout) — leave clicks alone.
        if (track.scrollWidth - track.clientWidth <= 2) return;
        dragging = true;
        track.classList.add(GRABBING_CLASS);
        try { track.setPointerCapture(pointerId); } catch (err) {}
      }
      e.preventDefault();
      track.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!isDown || (pointerId !== null && e.pointerId !== pointerId)) return;
      isDown = false;
      if (dragging) {
        track.classList.remove(GRABBING_CLASS);
        try { track.releasePointerCapture(pointerId); } catch (err) {}
        suppressClick = true;
        if (typeof onDragEnd === 'function') onDragEnd();
      }
      dragging = false;
      pointerId = null;
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', function (e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      }
    }, true);

    // Always cancel the browser's native image/link drag so a click-and-hold
    // reliably starts a carousel scroll instead of dragging the image.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initSection(section) {
    var track = section.querySelector('.oddit-section-products-highlight__track');
    var cards = section.querySelectorAll('.oddit-section-products-highlight__card');
    var prevBtn = section.querySelector('.oddit-section-products-highlight__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-products-highlight__arrow--next');

    if (!track || cards.length === 0) return;

    function getCardStep() {
      if (cards.length < 2) return cards[0].getBoundingClientRect().width;
      var first = cards[0].getBoundingClientRect();
      var second = cards[1].getBoundingClientRect();
      return second.left - first.left;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function atStart() {
      return track.scrollLeft <= 2;
    }

    function atEnd() {
      return track.scrollLeft >= maxScroll() - 2;
    }

    function scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
    }

    function updateArrows() {
      // Only relevant when the track actually overflows (desktop layout).
      var scrollable = maxScroll() > 2;
      if (prevBtn) prevBtn.hidden = !scrollable || atStart();
      if (nextBtn) nextBtn.hidden = !scrollable || atEnd();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getCardStep(), behavior: scrollBehavior() });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getCardStep(), behavior: scrollBehavior() });
      });
    }

    var scrollDebounce = null;
    track.addEventListener('scroll', function () {
      if (scrollDebounce) cancelAnimationFrame(scrollDebounce);
      scrollDebounce = requestAnimationFrame(updateArrows);
    }, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    } else {
      window.addEventListener('resize', updateArrows);
    }

    // After a mouse drag ends, glide smoothly to the nearest card instead of
    // letting scroll-snap re-engage with an instant jump. Snap is held off
    // during the glide so the smooth scroll isn't interrupted, then restored.
    function snapToNearest() {
      var max = maxScroll();
      if (max <= 2) return;
      var step = getCardStep();
      if (!step) return;

      var target = Math.round(track.scrollLeft / step) * step;
      target = Math.max(0, Math.min(target, max));

      track.style.scrollSnapType = 'none';
      var restore = function () { track.style.scrollSnapType = ''; };
      var fallback = setTimeout(restore, 700);
      track.addEventListener('scrollend', function onEnd() {
        clearTimeout(fallback);
        restore();
        track.removeEventListener('scrollend', onEnd);
      }, { once: true });

      track.scrollTo({ left: target, behavior: scrollBehavior() });
    }

    initDrag(track, snapToNearest);
    updateArrows();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
